export default __webpack_public_path__ + "static/media/brandenburg.722c3119.svg";